<cdk-virtual-scroll-viewport
  id="my-tabular-table"
  itemSize="40"
  class="h-full overflow-hidden"></cdk-virtual-scroll-viewport>
